.mentionAwareText {
  :global([data-markdown]) {
    margin-bottom: 0;
  }
}
